export const nop = () => null;